import { render, staticRenderFns } from "./PropertiesForRent.vue?vue&type=template&id=b549dbcc&scoped=true&"
import script from "./PropertiesForRent.vue?vue&type=script&lang=ts&"
export * from "./PropertiesForRent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b549dbcc",
  null
  
)

export default component.exports